import { render } from "./Inputi18n.vue?vue&type=template&id=7f13c201&scoped=true"
import script from "./Inputi18n.vue?vue&type=script&lang=js"
export * from "./Inputi18n.vue?vue&type=script&lang=js"

import "./Inputi18n.vue?vue&type=style&index=0&id=7f13c201&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f13c201"]])

export default __exports__